import { render, staticRenderFns } from "./ListadoTipoListaPrecio.vue?vue&type=template&id=165d9930"
import script from "./ListadoTipoListaPrecio.vue?vue&type=script&lang=js"
export * from "./ListadoTipoListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports